import { ConsignmentApiModel, ConsignmentParcelApiModel, SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { uid } from '../../../../lib/helpers/uid';

export function SmartSendItemsToConsignment(items: SmartSendItemApiModel[]) {
  const res: ConsignmentApiModel = { Parcels: [] };
  items.forEach((i) => {
    const parcel: ConsignmentParcelApiModel = {
      Contents: [],
      Dimensions: i.PackageDimensions,
      Id: i.Id,
      UID: uid(),
      CanAdd: i.Source.Id === 'grouped'
    };
    i.MarketplaceOrderLines.forEach((m) => {
      parcel.Contents.push({
        Id: m.Id,
        UID: uid(),
        Quantity: m.Quantity,
        Value: m.Value,
        Description: m.Product.Description
      });
    });
    res.Parcels.push(parcel);
  });
  return res;
}
